"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "optionalTrimmedText", {
    enumerable: true,
    get: function() {
        return optionalTrimmedText;
    }
});
const _zod = require("zod");
const optionalTrimmedText = (max)=>_zod.z.string().trim().max(max).nullish().transform((value)=>{
        if (value === null || value === undefined || value === '') {
            return undefined;
        }
        return value;
    }).optional();
